import React from "react";
import {Navigate} from "react-router-dom";

export function HomeView() {
    return (
        <Navigate to={"/search/artworks"}/>
    )
}